/*
 * @Description: 网络请求封装
 * @Author: pliybird
 * @Date: 2023-06-15 13:01:21
 * @LastEditTime: 2023-07-12 11:35:45
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */

import axios from "axios"
import qs from "qs"
import AppFunctions from "./AppFunctions";
const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL : '',
  timeout: 10000,  //网络请求时间：10秒  超过10秒则请求失败
  // withCredentials:true // 允许前端跨域
});

let isTokenRefreshing = false; // 标记是否正在刷新 token
let refreshSubscribers = []; // 存储 token 刷新期间的请求队列


//添加一个请求拦截器
instance.interceptors.request.use(config => {
  // console.log("config===",config)
  //发送post请求数据的统一处理
  // if (config.method === "post") {
  //     config.data = qs.stringify(config.data);
  // }
  let token = localStorage.getItem('token')
  if (!token) {
    return config
  }
  config.headers['Authorization'] = `Bearer ${token}`;
  return config;
}, err => {
  //请求错误
  return Promise.reject(err);
});

//添加一个响应拦截器
instance.interceptors.response.use(response => {
  // 接口请求成功
  if (response.status === 200) {
    return Promise.resolve(response.data)
  }
  return Promise.resolve(response)
}, error => {
  // 如果存在，说明 token 失效，需要刷新 token
  if (error.response && error.response.status === 401) {
    if (!isTokenRefreshing) {
      isTokenRefreshing = true;
      return AppFunctions.refreshToken()
        .then((newToken) => {
          // 刷新 token 成功后，更新请求头中的 token
          instance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
          // 执行刷新期间的请求队列
          refreshSubscribers.forEach((subscriber) => subscriber(newToken));
          refreshSubscribers = [];
          return instance(error.config);
        })
        .catch((refreshError) => {
          // 刷新 token 失败处理
          console.error('Token Refresh Error:', refreshError);
          // 清除 token 并跳转到首页
          localStorage.removeItem('token');
          window.location.href = '/';
          return Promise.reject(refreshError);
        })
        .finally(() => {
          isTokenRefreshing = false;
        });
    } else {
      // 在 token 刷新期间，将请求放入队列，等待刷新完成后再重新发送
      return new Promise((resolve) => {
        refreshSubscribers.push((newToken) => {
          error.config.headers['Authorization'] = `Bearer ${newToken}`;

          resolve(instance(error.config));
        });
      });
    }
  } else {
    return Promise.reject(error);
  }

});
export default instance;